export default "__VITE_ASSET__BbEumxLK__"